import { render, staticRenderFns } from "./respectScore.vue?vue&type=template&id=6ab22ae5&scoped=true&"
import script from "./respectScore.vue?vue&type=script&lang=js&"
export * from "./respectScore.vue?vue&type=script&lang=js&"
import style0 from "./respectScore.vue?vue&type=style&index=0&id=6ab22ae5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ab22ae5",
  null
  
)

export default component.exports